export default function truncateString(textToString, concatLength = 50) {
  return textToString.length > concatLength
    ? textToString.substring(0, concatLength) + '...'
    : textToString;
}
